import { useEffect, useState } from 'react';
import { mdiChatProcessing } from '@mdi/js';
import Icon from '@mdi/react';
import { useGetPerson } from '@my-pages/hooks/useGetPerson';

interface KundoChatButtonProps {}

const KundoChatButton = ({}: KundoChatButtonProps) => {
    const member = useGetPerson();
    const [chatAvailable, setChatAvailable] = useState<boolean>(false);

    useEffect(() => {
        if (!member) return clearScriptsEventListeners;

        //@ts-ignore
        window['$kundo_chat'] = window['$kundo_chat'] || {};

        //@ts-ignore
        window['$kundo_chat'].disable_widget = true;

        // window["$kundo_chat"].user = {
        //   name: member.fullname ?? "",
        //   email: member.emailaddress1 ?? ""
        // };

        const parent = document.getElementsByTagName('head')[0];
        const script = document.createElement('script');

        script.id = 'KundoChatScript';
        script.src = 'https://static-chat.kundo.se/chat-js/org/1171/widget.js';
        script.async = true;
        script.defer = true;

        parent.appendChild(script);

        window.document.addEventListener('kundo-chat:chat-available', () => {
            setChatAvailable(true);
        });
        window.document.addEventListener('kundo-chat:chat-unavailable', () => {
            setChatAvailable(false);
        });

        return clearScriptsEventListeners;
    }, [member]);

    const clearScriptsEventListeners = () => {
        const parent = document.getElementsByTagName('head')[0];
        const script = document.getElementById('KundoChatScript');
        if (script) parent.removeChild(script);
        window.document.removeEventListener('kundo-chat:chat-available', () => {});
        window.document.removeEventListener('kundo-chat:chat-unavailable', () => {});
    };

    useEffect(() => {
        const interval = setInterval(() => {
            //@ts-ignore
            if (!window['$kundo_chat'].hide_widget) return;
            clearInterval(interval);
            //@ts-ignore
            window['$kundo_chat'].hide_widget();
        }, 50);

        return () => {
            if (interval) clearInterval(interval);
        };
    }, []);

    const startChat = () => {
        //@ts-ignore
        window['$kundo_chat'].start_chat();
    };

    if (!chatAvailable) return <></>;

    return (
        <button
            id='kundo-chat-button'
            className={`btn btn-primary`}
            onClick={startChat}
            title='Chatta med oss'
        >
            <Icon
                path={mdiChatProcessing}
                className='mdi'
            />
        </button>
    );
};

export default KundoChatButton;
